import { render, staticRenderFns } from "./TransactionViewDefault.vue?vue&type=template&id=543ff19e&scoped=true&"
import script from "./TransactionViewDefault.vue?vue&type=script&lang=js&"
export * from "./TransactionViewDefault.vue?vue&type=script&lang=js&"
import style0 from "./TransactionViewDefault.vue?vue&type=style&index=0&id=543ff19e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543ff19e",
  null
  
)

export default component.exports